import { Entry } from '../Entry'

export function Entry20221130() {
  return (
    <Entry title="30/11/2022 - v3.2.11">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/13538/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
